import { useHistory, useLocation } from "react-router-dom";

export function useQueryParams() {
  const history = useHistory();
  const location = useLocation();

  const addQueryParam = (key, value) => {
    const params = new URLSearchParams(location.search);
    params.set(key, value);
    history.replace({
      search: params.toString(),
    });
  };

  const addAllQueryParams = (values) =>{
    const params = new URLSearchParams(location.search);
    for(const key in values){
      params.set(key,values[key]);
    }
    history.replace({
      search: params.toString(),
    });
  }

  const removeQueryParam = (key) => {
    const params = new URLSearchParams(location.search);
    params.delete(key);

    history.replace({
      search: params.toString(),
    });
  };

  const removeGivenQueryParams =( values = {}) =>{
    const params = new URLSearchParams(location.search);
    
    for(const key in values){
      params.delete(key);
    }

    history.replace({
      search: params.toString(),
    });
  }

  const clearAllQueryParam = () => {
    history.replace({ search: "" });
  };

  const getAllQueryParams = () =>{
    const queryParams = new URLSearchParams(location.search);
    const search_params = Object.fromEntries(queryParams.entries());
    return search_params;
  }

  return {
    addQueryParam,
    removeQueryParam,
    addAllQueryParams,
    clearAllQueryParam,
    removeGivenQueryParams,
    getAllQueryParams
  };
}
